/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Todo, saveTodo, deleteTodo, saveTodoToggle } from 'api/fakeAPI'
import { AppThunk } from 'app/store'

const initialState: Array<Todo> = []

const todos = createSlice({
  name: 'todos',
  initialState: initialState,
  reducers: {
    addTodo(state, { payload }: PayloadAction<Todo>) {
      state.push(payload)
    },
    removeTodo(state, { payload }: PayloadAction<string>) {
      return state.filter((todo) => todo.id !== payload)
    },
    toggleTodo(state, { payload }: PayloadAction<string>) {
      const todo = state.find((todo) => todo.id === payload)
      if (todo) {
        todo.completed = !todo.completed
      }
    }
  }
})

export const { addTodo, removeTodo, toggleTodo } = todos.actions

export default todos.reducer

export const handleDeleteTodo =
  (todo: Todo): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(removeTodo(todo.id))
      await deleteTodo(todo.id)
    } catch (err: any) {
      console.log('there was an error deleting the todo ' + err.toString())
      dispatch(addTodo(todo))
    }
  }

export const handleAddTodo =
  (text: string, cb: () => void): AppThunk =>
  async (dispatch) => {
    try {
      const toDo = await saveTodo(text)
      dispatch(addTodo(toDo))
      cb()
    } catch (err: any) {
      console.log('there was an error adding todo ' + err.toString())
    }
  }

export const handleToggle =
  (id: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(toggleTodo(id))
      await saveTodoToggle(id)
    } catch (err: any) {
      console.log('there was an error toggling the todo ' + err.toString())
      dispatch(toggleTodo(id))
    }
  }
